var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.853,
    height: 34.72,
    viewBox: "0 0 158.853 34.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.36 -1303.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.692,1303.63h15.527q6.308,0,10,3.181t3.693,9.435a23.839,23.839,0,0,1-.539,4.96q-1.834,9-6.551,13.074t-13.559,4.07h-15.9Zm8.518,26.957a11.557,11.557,0,0,0,4.529-.782,7.127,7.127,0,0,0,3.154-2.831,17.758,17.758,0,0,0,2.13-5.769,25.524,25.524,0,0,0,.593-4.744q0-2.857-1.483-3.963a8.207,8.207,0,0,0-4.825-1.1h-4.1l-4.1,19.193Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M544.419,1303.63h10.136l-7.332,34.72H537.087Z",
    transform: "translate(-396.244 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M728.009,1303.63H746.07q4.852,0,7.494,2.48a8.733,8.733,0,0,1,2.642,6.685,17.343,17.343,0,0,1-.323,3.181,13.773,13.773,0,0,1-3.046,6.119,15.557,15.557,0,0,1-5.58,4.125,2.927,2.927,0,0,1,.755,1.078,14.644,14.644,0,0,1,.593,1.941l2.555,9.111H740.592l-2.393-8.356a2.582,2.582,0,0,0-.782-1.375,2.665,2.665,0,0,0-1.644-.4h-2.858l-2.1,10.135H720.677Zm11.915,16.821a5.348,5.348,0,0,0,5.607-4.475,13.346,13.346,0,0,0,.216-1.725,2.673,2.673,0,0,0-.836-2.13,4.115,4.115,0,0,0-2.723-.728h-5.661l-1.941,9.057Z",
    transform: "translate(-563.582 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1113.574,1320.774l-8.734-17.144h12.077l4.421,9.112,8.357-9.112h12.076l-15.958,17.144,9.111,17.576h-12.238l-4.744-9.435-8.68,9.435h-12.238Z",
    transform: "translate(-906.613 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1558.375,1333.785a30.418,30.418,0,0,1,4.22-4.592q2.362-2.1,6.132-5.017l.9-.69a58.835,58.835,0,0,0,5.229-4.247,6.516,6.516,0,0,0,1.831-3.345,4.85,4.85,0,0,0,.159-1.168,2.146,2.146,0,0,0-1.035-1.964,6.293,6.293,0,0,0-3.212-.637,31.009,31.009,0,0,0-10.052,1.858l1.805-8.494a47.5,47.5,0,0,1,6.655-1.354,39.033,39.033,0,0,1,6.211-.5q4.989,0,7.618,2.177a7.429,7.429,0,0,1,2.628,6.052,13.968,13.968,0,0,1-.319,2.814,14.18,14.18,0,0,1-2.362,5.6,25.428,25.428,0,0,1-5.123,4.751q-.372.319-2.07,1.54t-2.92,2.256c-.815.69-.6.418-.6.462h13.2l-1.919,9.067h-27.944Z",
    transform: "translate(-1326.254 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.f00437229b62466de2455f6a43c3adc7.svg";
export { ForwardRef as ReactComponent };